import React from 'react';
import PropTypes from 'prop-types';
import { GlossaryWeb } from '@learningblocks/storybook-components/lib/Glossary/GlossaryWeb';
import { GlossaryMob } from '@learningblocks/storybook-components/lib/Glossary/GlossaryMob';
import { GlossaryTab } from '@learningblocks/storybook-components/lib/Glossary/GlossaryTab';
import {MediaType} from '@learningblocks/storybook-components/lib/MediaType';
import {Utilities} from '@learningblocks/exp-constants';
const {VIEW_TYPE} = Utilities;

//import style from './style.module.scss';

/**
 * MainComponent:
 *  - Component puts together all child components in Glossary
 *    and provider their props and state
 */
function MainComponent(props) {
  const mediaType = React.useContext(MediaType.Context);

  const renderByMediaType = () => {
    switch (mediaType) {
      case VIEW_TYPE.TAB:
        return <GlossaryTab closeGlossary={props.closeGlossary} />;
      case VIEW_TYPE.MOB:
        return <GlossaryMob closeGlossary={props.closeGlossary} />;
      default:
        return <GlossaryWeb closeGlossary={props.closeGlossary} />;
    }
  };

  return renderByMediaType();
}

MainComponent.propTypes = {
  /**
   * function involked to close the glossary
   */
  closeGlossary: PropTypes.func.isRequired,
};

MainComponent.defaultProps = {};

const GlossaryDispatch = React.createContext(null);

/**
 * Provider:
 *  - Component wraps its childern with  Glossary-State-Provider.
 */
export function Provider(props) {
  return (
    <GlossaryDispatch.Provider
      value={props.hook}>
      {props.children}
    </GlossaryDispatch.Provider>
  );
}

const ProviderSharedPropTypes = {
  /**
   * String value searched in glossary
   */
  searchText: PropTypes.string.isRequired,
  /**
   * List of categories to be displayed for the search Glossary Items
   */
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
    })
  ).isRequired,
  /**
   * Async function to fetch glossary list
   */
  fetchGlossaryList: PropTypes.func.isRequired,
  /**
   * Async function to fetch glossary Item content
   */
  fetchGlossaryItem: PropTypes.func.isRequired,
};

Provider.propTypes = {
  ...ProviderSharedPropTypes,
  /**
   *  Main Glossary components that needs glossary state.
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

Provider.defaultProps = {
  searchText: '',
  categories: [],
};

/**
 * Glossary:
 *  A Glossary lising for major components
 */
function Glossary(props) {
  return (
    <Provider
      hook={props.hook}
      searchText={props.searchText}
      categories={props.categories}
      fetchGlossaryItem={props.fetchGlossaryItem}
      fetchGlossaryList={props.fetchGlossaryList}>
      <MainComponent closeGlossary={props.closeGlossary} />
    </Provider>
  );
}

Glossary.propTypes = {
  ...MainComponent.propTypes,
  ...ProviderSharedPropTypes,
};

Glossary.defaultProps = Provider.defaultProps;

export {Glossary, GlossaryDispatch};
